import styled from 'styled-components'

export const Wrapper = styled.div``

export const Main = styled.div`
  z-index: 999;
  transform: matrix(1, 0, 0, 1, 0, 0);

  top: auto;
  bottom: 12px;
  right: 20px;
  left: auto;
  user-select: none;

  position: fixed;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  width: 70px;
  height: 70px;
  border-radius: 40px;
  background: #8e489c;

  :hover {
    cursor: pointer;
    transform: scale(1.2);
    transition: all 0.2s ease-in;
  }

  .iconHide {
    opacity: 0 !important;
  }
`

export const BoxIcon = styled.div`
  opacity: 1;
  transition: opacity 0.5s linear;
`
